var lib_core = require("lib-core");

var MovingStateMachine = require("./../moving/movingStateMachine.js");

var HandlesStateMachine = function (root, editorModel, model) {
    var self = this;

    this.root = root;
    this.editorModel = editorModel;
    this.model = model;

    lib_core.StateMachine.call(this);

    this.addTransition("idle", "idle",
        function (cEvent) {
            return cEvent.type() == lib_core.GuiEvents.HANDLE_MOUSE_OVER;
        },
        function (cEvent) {
            var lastElement = cEvent.element();
            self.handleIndex = cEvent.data('handleIndex');

            // highlight just one
            if(lastElement.interactionModel) {
                if(lastElement.interactionModel.handles) {
                    lastElement.interactionModel.handles.forEach(function(idx, obj) {
                        obj.highlighted(false);
                    });
                }
            }
            lastElement.highlighted(true);
        });

    this.addTransition("idle", "idle",
        function (cEvent) {
            return cEvent.type() == lib_core.GuiEvents.HANDLE_MOUSE_OUT;
        },
        function (cEvent) {
            var lastElement = cEvent.element();
            self.handleIndex = cEvent.data('handleIndex');

            lastElement.highlighted(false);
        });

    this.addTransition("idle", "handle_mouse_down",
        function(cEvent){
            return  cEvent.type() == lib_core.GuiEvents.HANDLE_MOUSE_DOWN &&
                    cEvent.data('handleIndex') != -1;
        },
        function(cEvent){
            self.handleIndex = cEvent.data('handleIndex');
            self.model.movingCollection.add(cEvent.element());

            var lastElement = cEvent.element();

            if(!cEvent.data('shiftKey')) {
                // highlight just one
                if(lastElement.interactionModel) {
                    if(lastElement.interactionModel.handles) {
                        lastElement.interactionModel.handles.forEach(function(idx, obj) {
                            obj.highlighted(false);
                        });
                    }
                }

                lastElement.highlighted(true);
                self.model.activeHandle = lastElement;
            }
        }
    );

    this.addTransition("handle_mouse_down","idle",
        function(cEvent) {
            return cEvent.type() == lib_core.GuiEvents.CANVAS_MOUSE_UP ||
                cEvent.type() == lib_core.GuiEvents.EDITOR_MOUSE_UP ||
                cEvent.type() == lib_core.GuiEvents.HANDLE_MOUSE_UP;
        },
        function(cEvent){
            if(self.model.activeHandle) self.model.activeHandle.highlighted(false);
            self.model.movingCollection.removeAll();
            self.handle(cEvent);
        }
    );

    this.addTransition("handle_mouse_down","idle",
        function(cEvent) {
            return cEvent.isKeyPressed('escape');
        },
        function(cEvent){
            self.handle(cEvent);
        }
    );

    var movingStateMachine = new MovingStateMachine(this.root, model, editorModel);
    this.append("moving", movingStateMachine, "handle_mouse_down", null, "handle_mouse_down", null);
};

lib_core.inherit(HandlesStateMachine, lib_core.StateMachine);

module.exports = HandlesStateMachine;


